/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconPlayer: {
  name: 'player';
  data: string;
} = {
  name: 'player',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M314.419 12.317c37.098 4.821 66.06 45.185 66.06 93.906 0 26.98-9.241 51.072-23.476 68.24 77.149 14.515 82.984 144.563 82.984 235.849h-53.504l-14.194 190.539H236.347L223.79 410.312h-50.773c0-91.544-1.839-223.87 82.439-236.942-13.622-17.089-22.384-40.835-22.384-67.147 0-51.966 33.077-93.906 73.702-93.906 2.536 0 5.17-.379 7.645 0z"/></svg>`,
};
